export const TOP_CITIES = [
  { name: "London", name_zh: "伦敦", link: "london-1811028205760" },
  { name: "Glasgow", name_zh: "格拉斯哥", link: "glasgow-1811024356803" },
  { name: "Coventry", name_zh: "考文垂", link: "coventry-1811022688464" },
  { name: "Birmingham", name_zh: "伯明翰", link: "birmingham-1811028953945" },
  { name: "Nottingham", name_zh: "诺丁汉", link: "nottingham-1811025104223" },
  { name: "Sheffield", name_zh: "谢菲尔德", link: "sheffield-1811027902898" },
  { name: "Manchester", name_zh: "曼彻斯特", link: "manchester-1811021510595" },
  { name: "Edinburgh", name_zh: "爱丁堡", link: "edinburgh-1811029850773" },
  { name: "Leicester", name_zh: "莱斯特", link: "leicester-1811027154774" },
  { name: "Cardiff", name_zh: "卡迪夫", link: "cardiff-1811021315133" },
  { name: "Leeds", name_zh: "利兹", link: "leeds-1811025399073" },
  { name: "Newcastle", name_zh: "纽卡斯尔", link: "newcastle-upon-tyne-1811022588361" },
  { name: "Aberdeen", name_zh: "阿伯丁", link: "aberdeen-1811021824528" },
  { name: "Portsmouth", name_zh: "朴茨茅斯", link: "portsmouth-1811020065723" },
  { name: "Cambridge", name_zh: "剑桥", link: "cambridge-1811025371107" },
  { name: "Oxford", name_zh: "牛津", link: "oxford-1811023030854" },
  { name: "Southampton", name_zh: "南安普顿", link: "southampton-1811022771524" },
  { name: "Exeter", name_zh: "埃克塞特", link: "exeter-1811027484452" },
  { name: "Bournemouth", name_zh: "伯恩茅斯", link: "bournemouth-1811027075639" },
  { name: "Belfast", name_zh: "贝尔法斯特", link: "belfast-1811021897138" },
  { name: "Bristol", name_zh: "布里斯托尔", link: "bristol-1811028541951" },
  { name: "Canterbury", name_zh: "坎特伯雷", link: "canterbury-1811026296205" },
  { name: "Dublin", name_zh: "都柏林", link: "dublin-1811234255126" },
  { name: "Swansea", name_zh: "斯旺西", link: "swansea-1811021718098" },
  { name: "Loughborough", name_zh: "拉夫堡", link: "loughborough-1811023994102" },
  { name: "Brighton", name_zh: "布莱顿", link: "brighton-and-hove-1811029325591" },
  { name: "Derby", name_zh: "德比", link: "derby-1811027042281" },
  { name: "Hatfield", name_zh: "哈特菲尔德", link: "hatfield-1811227320022" },
  { name: "Lincoln", name_zh: "林肯", link: "lincoln-1811026319691" },
  { name: "Luton", name_zh: "卢顿", link: "luton-1811021378066" },
  { name: "Plymouth", name_zh: "普利茅斯", link: "plymouth-1811024617468" },
  { name: "Dallas", name_zh: "达拉斯", link: "dallas-1811050789451" },
  { name: "Cork", name_zh: "科克", link: "cork-1905110396319" },
  { name: "Melbourne", name_zh: "墨尔本", link: "melbourne-1811011846366" },
  { name: "Sydney", name_zh: "悉尼", link: "sydney-1811019193619" },
  { name: "Adelaide", name_zh: "阿德莱德", link: "adelaide-1811022271790" },
  { name: "Brisbane", name_zh: "布里斯班", link: "brisbane-1811022382320" },
  { name: "Canberra", name_zh: "堪培拉", link: "canberra-1811028680774" },
  { name: "Gold Coast", name_zh: "黄金海岸", link: "gold-coast-1811055204067" },
  { name: "Perth", name_zh: "珀斯", link: "perth-1811021246766" },
  { name: "Ann Arbor", name_zh: "安娜堡", link: "ann-arbor-2211094460561" },
  { name: "Atlanta", name_zh: "亚特兰大", link: "atlanta-2103038343998" },
  { name: "Austin", name_zh: "奥斯汀", link: "austin-1811059470166" },
  { name: "Champaign", name_zh: "香槟", link: "champaign-2211098678696" },
  { name: "Chicago", name_zh: "芝加哥", link: "chicago-1811055213730" },
  { name: "Houston", name_zh: "休斯敦", link: "houston-1811053554207" },
  { name: "Los Angeles", name_zh: "洛杉矶", link: "los-angeles-1811059549842" },
  { name: "Lubbock", name_zh: "拉伯克", link: "lubbock-2208021988942" },
  { name: "Miami", name_zh: "迈阿密", link: "miami-1811158634551" },
  { name: "New York", name_zh: "纽约", link: "new-york-city-1811153579499" },
  { name: "Philadelphia", name_zh: "费城", link: "philadelphia-1811050668830" },
  { name: "San Francisco", name_zh: "旧金山", link: "san-francisco-1811261246298" },
  { name: "Seattle", name_zh: "西雅图", link: "seattle-1811059396725" },
  { name: "Tampa", name_zh: "坦帕", link: "tampa-1811228359390" },
  { name: "Washington DC", name_zh: "华盛顿特区", link: "washington-dc-1811157116879" },
  { name: "Burnaby", name_zh: "本拿比", link: "burnaby-2404052176075" },
  { name: "Hamilton", name_zh: "汉密尔顿", link: "hamilton-2406127737096" },
  { name: "Mississauga", name_zh: "密西沙加", link: "mississauga-2403136242072" },
  { name: "Ottawa", name_zh: "渥太华", link: "ottawa-2304201785556" },
  { name: "Toronto", name_zh: "多伦多", link: "toronto-1912205118632" },
  { name: "Vancouver", name_zh: "温哥华", link: "vancouver-1911021542675" },
  { name: "Waterloo", name_zh: "滑铁卢", link: "waterloo-2402226880061" },
];

export const TOP_COUNTRIES = [
  { name: "United Kingdom", name_zh: "英国", link: "united-kingdom-1811011902157" },
  { name: "United States", name_zh: "美国", link: "united-states-1811011842700" },
  { name: "Australia", name_zh: "澳大利亚", link: "australia-1811019798408" },
  { name: "Germany", name_zh: "德国", link: "germany-1911265061393" },
  { name: "Ireland", name_zh: "爱尔兰", link: "ireland-1904178897698" },
  { name: "France", name_zh: "法国", link: "france-1911269874240" },
  { name: "Spain", name_zh: "西班牙", link: "spain-2010151748622" },
  { name: "Canada", name_zh: "加拿大", link: "canada-1811011406255" },
];
